export const getDocHpExecutiveKeyPointsInitialValues = () => ['• Point 1', '• Point 2', '• Point 3']
